import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import BroadcastRequests from "@/api/broadcast/broadcast.requests.ts";
import { useLang } from "@/hooks/useLang.ts";

export const BROADCAST_KEYS = {
  broadcasts: (lang: string, category?: string, isKids?: boolean, token?: string) => [
    "tv-list",
    lang,
    category,
    isKids,
    token,
  ],
  broadcastsCategory: (lang: string, isKids: boolean) => ["tv-list-category", lang, isKids],
  detail: (lang: string, id: number) => ["broadcast-detail", lang, id],
};

export const useGetBroadcasts = (category?: string) => {
  const lang = useLang();
  const token = localStorage.getItem("splay:token") || "";
  const profileAge = localStorage.getItem("splay:profileAge");
  const isKids: boolean = profileAge ? parseInt(profileAge) < 16 : false;

  return useSuspenseQuery({
    queryKey: BROADCAST_KEYS.broadcasts(lang, category, isKids, token),
    queryFn: () =>
      token
        ? BroadcastRequests.getBroadcasts({ category: category ?? "", isKids })
        : BroadcastRequests.getBroadcastsNoAuth({ category: category ?? "", isKids }),
    staleTime: 1000 * 60 * 15,
  });
};

export const useGetBroadcastCategories = () => {
  const lang = useLang();
  const profileAge = localStorage.getItem("splay:profileAge");
  const isKids: boolean = profileAge ? parseInt(profileAge) < 16 : false;

  return useQuery({
    queryKey: BROADCAST_KEYS.broadcastsCategory(lang, isKids),
    queryFn: () => BroadcastRequests.getBroadcastCategories(isKids),
    staleTime: 1000 * 60 * 15,
  });
};

export const useGetBroadcastDetail = (id: number) => {
  const lang = useLang();
  return useQuery({
    queryKey: BROADCAST_KEYS.detail(lang, id),
    queryFn: () => BroadcastRequests.getBroadCardDetail(id),
    staleTime: 0,
  });
};
